
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gain/airdrop-gain",
      function () {
        return require("private-next-pages/gain/airdrop-gain.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gain/airdrop-gain"])
      });
    }
  